//import { constants } from 'buffer';
import { Log, User, UserManager } from 'oidc-client';

//import { Constants } from '../helpers/Constants';

const CLIENT_ROOT = process.env.REACT_APP_CLIENT_ROOT;
const CLIENT_SCOPE = process.env.REACT_APP_CLIENT_SCOPE;
const CLIENT_ID = process.env.REACT_APP_CLIENT_ID;
const STS_AUTHORITY = process.env.REACT_APP_STS_AUTHORITY;

export class AuthService {
  public userManager: UserManager;

  constructor() {
    const settings = {
      authority: `${STS_AUTHORITY}`,
      client_id: `${CLIENT_ID}`,
      redirect_uri: `${CLIENT_ROOT}signin-callback.html`,
      silent_redirect_uri: `${CLIENT_ROOT}silent-renew.html`,
      // tslint:disable-next-line:object-literal-sort-keysnp
      post_logout_redirect_uri: `${CLIENT_ROOT}`,
      response_type: 'code',
      scope: `${CLIENT_SCOPE}`,
    };
    this.userManager = new UserManager(settings);

    Log.logger = console;
    Log.level = Log.INFO;
  }

  public getUser(): Promise<User | null> {
    return this.userManager.getUser();
  }

  public login(): Promise<void> {
    return this.userManager.signinRedirect({
      extraQueryParams: { kc_idp_hint: 'oidc' },
    });
  }

  public renewToken(): Promise<User> {
    return this.userManager.signinSilent();
  }

  public logout(): Promise<void> {
    return this.userManager.signoutRedirect();
  }
}
